// src/pages/educator/LegacyClassroomRedirect.js
//
// Keeps the 36 old classroom URLs working.
//
// The per-state pages are gone, replaced by one EducatorClassroom. But their
// URLs are in teachers' bookmarks, in emails you've already sent, and in the
// navigate() call inside DashboardEducator:
//
//     /educator/va/va-3rd-educator-classroom
//     /educator/nc/nc-1st-educator-classroom
//
// Rather than 404 those, this parses the grade out of the legacy slug and
// renders the unified classroom directly — same component, same data, no
// visible redirect and no extra page load.
//
// Anything under /educator/:state/ that ISN'T a classroom slug is passed
// through untouched, so this route can't swallow the subject pages.

import React from "react";
import { useParams, Navigate } from "react-router-dom";
import EducatorClassroom from "./EducatorClassroom";

const GRADE_RE = /\b(k|prek|[0-9]+(?:st|nd|rd|th))\b/;

export default function LegacyClassroomRedirect() {
  const { state = "", legacySlug = "" } = useParams();
  const slug = String(legacySlug).toLowerCase();

  // Not a classroom URL — let the app's other routes handle it. Without this
  // guard a path like /educator/va/va-3rd-educator-science would render a
  // classroom instead of the science portal.
  if (!slug.includes("classroom")) {
    return <Navigate to={`/educator/${state}/${legacySlug}`} replace />;
  }

  // "va-3rd-educator-classroom" -> "3rd"
  const match = slug.match(GRADE_RE);
  const grade = match ? match[1] : "";

  // Rendered rather than redirected: EducatorClassroom falls back to the
  // educator's own profile when the route doesn't carry a usable grade, so
  // even an unparseable legacy slug lands somewhere correct.
  return <EducatorClassroom key={`${state}-${grade}`} />;
}
